module.exports = __webpack_public_path__ + "media/assets/images/wallpapers/unox_wallpaper-cf7ed67f2054a379578afea814e67da3.jpg";